import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";
import {scraperRegister} from "../../services/scraperRegister";
import {cartRegister} from "../../services/cartRegister";
import {BeatLoader} from "react-spinners";
import {EventEmitter} from "../../services/eventRegister";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import { Line } from 'rc-progress';

class SignupAdsFacebookCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            industry: "",
            location: "",
            error: false,
            progress: 0,
            custom_slides: []
        };
    };

    componentWillMount(){
        let cart = cartRegister.get();
        let custom_slides = [];

        if(cart.admin_slideshow_images){
            custom_slides = cart.admin_slideshow_images.filter((item) => {
                try{
                    return item.images.small && item.selected;
                }catch (e) {
                    return false
                }
            }).sort((a, b) => (a.number > b.number) ? 1 : -1).map((item) => {
                return item.images.small;
            });
        }

        try {
            this.setState({
                industry: cart.industry.name,
                location: cart.company_location.name,
                custom_slides: custom_slides
            });
        }catch (e) {}
    }

    componentDidMount() {
        try {
            EventEmitter.on('carousel', (value) => {
                if(value && this.state.custom_slides.length < 1){
                    this.setState({items: value});
                }else if(this.state.custom_slides.length > 0){
                    this.setState({items: this.state.custom_slides});
                }
            });
        }catch (e) {}
        try {
            EventEmitter.on('carousel-error', (value) => {
                this.setState({error: value});
            });
        }catch (e) {}
        try {
            EventEmitter.on('carousel-progress', (value) => {
                this.setState({progress: value});
            });
        }catch (e) {}
        try {
            let data = carouselRegister.get();
            if(data && this.state.custom_slides.length < 1){
                this.setState({items: data});
            }else if(this.state.custom_slides.length > 0){
                this.setState({items: this.state.custom_slides});
            }
        }catch (e) {}
        try {
            let error = carouselRegister.getError();
            this.setState({error: error});
        }catch (e) {}
        try {
            let progress = carouselRegister.getProgress();
            this.setState({progress: progress});
        }catch (e) {}
        try {
            const slider = document.querySelector('#carousel_slider');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
                console.log(walk);
            });
        }catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("signup-ads-facebook-carousel", item);
    }

    render() {
        return (
            <div id={"carousel_slider"} className={
                cx(Styles.container,
                    {
                        [Styles.containerEmpty]: this.state.items.length < 1 || this.state.error,
                    })
            }>
                {
                    this.state.items.length > 0 && !this.state.error &&
                    this.state.items.map((item) => {
                        return(
                            <div className={Styles.containerItem}>
                                <div style={{backgroundImage: "url(" + item + ")"}} className={Styles.containerItemImage}></div>
                                <div className={Styles.containerItemTitle}>
                                    {this.state.industry}
                                </div>
                                <div className={Styles.containerItemDescription}>
                                    {this.state.location}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    this.state.items.length < 1 && !this.state.error &&
                    <div className={Styles.containerLoading}>
                        <div className={Styles.containerLoaderProgress}>
                            <Line percent={this.state.progress} strokeWidth="3" strokeLinecap={"square"} strokeColor="#41CBC7" />
                        </div>
                        <div className={Styles.containerLoadingText}>
                            {this._renderText("item_1")}
                        </div>
                    </div>
                }
                {
                    this.state.error &&
                    <div className={Styles.containerLoading}>
                        <div className={cx(Styles.containerLoadingText, Styles. containerLoadingTextError)}>
                            {this._renderText("item_2")}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default SignupAdsFacebookCarousel;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook-carousel/component.js